// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"ec6421b8","112":"2facd8f7","533":"09d65f69","538":"bc228199","610":"820269e0","702":"13818797","802":"3a89ee1b","909":"d3a81fb2","972":"74f784f7"}[chunkId] + ".chunk.js";
};